import React, { Component } from "react";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import DoneIcon from '@material-ui/icons/Done';
import ClearIcon from '@material-ui/icons/Clear';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../../loginService/logout";

import { NotificationManager, NotificationContainer } from 'react-notifications';

const backend = require('../../../config.js').backend;

const isBankAccNameValid = (name) => {

    var isValid = true;
    var error = ''
    if (!name) {
        error = "Cannot be empty";
        isValid = false
    }

    if (typeof name !== "undefined" && name !== '') {
        // if(!x.match(/^[a-zA-Z0-9]+$/)){
        // if(!x.match(/^[a-zA-Z0-9-_!@#$%^_|]+$/)){            
        //     error = "Only letters"
        //     isValid = false
        // }     
        isValid = true
    }
    console.log(error)
    return isValid
}

class BankAccRow extends Component {

    constructor(props) {

        super(props);

        this.state = {

            account: props.account,
            accountId: props.account.BankAccID,
            accountName: props.account.BankAccName,
            accountEditName: '',
            editing: false,
            staffid: sessionStorage.getItem('id_e'),
            redirectLogout: false
        }

        this.updateBankAcc = this.updateBankAcc.bind(this);
        this.callApiToUpdateBankAcc = this.callApiToUpdateBankAcc.bind(this);
        this.handleDeleteAcc = this.handleDeleteAcc.bind(this);
        // this.isNameValid = this.isNameValid.bind(this);

    }

    componentDidMount() {

        this.setState({ accountEditName: this.state.accountName })

    }


    callApiToUpdateBankAcc = _ => {

        var { accountId } = this.state;
        // var {accountName} = this.state;
        var { accountEditName } = this.state;
        var { staffid } = this.state;

        var that = this;

        console.log('callApiToUpdateBankAcc', accountId, accountEditName)

        return new Promise(function (resolve, reject) {


            fetch(backend + `api/v1/bankacc/` + staffid + `/` + accountId + `?accname=` + accountEditName, {
                method: 'PUT',
                credentials: "include"
            })
                .then(response => response.json())
                .then(response => {
                    // console.log(response);
                    if (response.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (response.hasOwnProperty('message')) {
                        reject(response.message)
                    }
                    else {
                        resolve(response);
                    }

                })
                .catch(function (v) {
                    // console.log('error: ', v);
                    reject(v);
                });

        })

    }

    handleDeleteAcc = _ => {
        var { accountId } = this.state;
        var { accountName } = this.state;
        var { staffid } = this.state;
        var that = this;

        console.log('deleteAcc', accountId, accountName, staffid);
        // windows warning

        var answer = window.confirm("Are you sure you want to delete bank account " + accountName + " ?")

        if (answer) {

            fetch(backend + `api/v1/bankacc/` + accountId + '/' + staffid, {
                method: 'DELETE',
                credentials: "include"
            })
                .then(response => response.json())
                .then((response) => {
                    // console.log(response);
                    if (response.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (response.Error !== undefined) {
                        NotificationManager.error((response.Error).toString());
                    }
                    else {
                        // Delete from display
                        this.props.deleteFromAccountList(accountId);
                        NotificationManager.success('Bank account is deleted successfully');

                    }

                })
                .catch(err => console.error(err));

        } else {
            // Do nothing!
        }

    }


    updateBankAcc = _ => {

        console.log('updateBankAcc');
        const { accountName } = this.state;

        //validate the inputs
        if (isBankAccNameValid(accountName)) {
            console.log('isBankAccNameValid is true');

            this.callApiToUpdateBankAcc()
                .then((result) => {

                    // console.log(result);
                    if (result) {

                        NotificationManager.success('Updated succesfully!');
                        this.getAccountByIdAndUpdateState();
                        // this.disableAccountEdit();
                        this.setState({ editing: false });

                    }

                })
                .catch((err) => {

                    console.log(err)
                    NotificationManager.error('Please check your input !');

                })

        }

        else {

            console.log('isBankAccNameValid is false',);
            // Notify wrong inputs
            NotificationManager.error('Please check your input !');

        }

    }

    getAccountByIdAndUpdateState = _ => {

        const { accountId } = this.state;
        var that = this;

        var url = `api/v1/bankacc/` + accountId

        fetch(backend + url, {
            method: 'GET',
            credentials: "include"
        })
            .then(response => response.json())
            .then((data) => {
                console.log(data);

                if (data.redirect) {
                    that.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else {
                    this.setState({ account: data[0] });
                    this.setState({ accountName: data[0].BankAccName });
                }
            })
            .catch((err) => {
                console.log('getPlanById error', err);
            })

    }


    enableAccountEdit = _ => {

        this.setState({ editing: true });
    }

    disableAccountEdit = _ => {
        const { account } = this.state;
        this.setState({ editing: false });
        this.setState({ accountName: account.BankAccName });
        this.setState({ accountEditName: account.BankAccName });

    }

    handleNameChange = event => {
        console.log('handleNameChange', event.target.value);
        // this.setState({accountName: event.target.value})
        this.setState({ accountEditName: event.target.value })
    }


    render() {

        const { account } = this.state;
        const { accountId } = this.state;
        const { accountEditName } = this.state;
        var { editing } = this.state;

        // console.log('account', account)

        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        return (

            <tr key={accountId}>

                {editing
                    ? <td>
                        <input type="text" value={accountEditName} onChange={this.handleNameChange} />
                        <DoneIcon onClick={() => this.updateBankAcc()} />
                        <ClearIcon onClick={() => this.disableAccountEdit()} />
                    </td>
                    : <td> {account.BankAccName}
                        <EditIcon onClick={() => this.enableAccountEdit()} />
                    </td>
                }

                <td><DeleteIcon onClick={() => this.handleDeleteAcc()} /></td>
            </tr>


        )
    }

}

class AddNewBankAccPopup extends Component {

    constructor(props) {

        super(props);
        this.state = {
            value: '',
            staffid: sessionStorage.getItem('id_e'),
            redirectLogout: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    createNewBankAcc = _ => {

        const { value } = this.state;
        const { staffid } = this.state;
        var that = this;

        return new Promise(function (resolve, reject) {
            return fetch(backend + `api/v1/bankacc/` + staffid + `?accname=` + value, {
                method: 'POST',
                credentials: "include"
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);

                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (data.length && 'BankAccID' in data[0]) {
                        var id = data[0].BankAccID;
                        console.log(id)
                        resolve(id);
                    }
                    else {
                        reject(data)
                    }
                })
                .catch(err => err);

        })

    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    handleSubmit(event) {
        // alert('A name was submitted: ' + this.state.value);
        // event.preventDefault();
        const { value } = this.state;

        if (isBankAccNameValid(value)) {

            this.createNewBankAcc()
                .then(id => {
                    console.log('finish adding new group to SQL', id);

                    if (id) {

                        // var id = 100; //testing
                        var account = {
                            BankAccName: value,
                            BankAccID: id
                        }

                        // Add new bank account to the list
                        this.props.addToAccountList(account);
                        NotificationManager.success('Bank account is created successfully');
                        this.props.closePopup();

                    }

                })
                .catch(err => {
                    NotificationManager.error(err.toString());
                });

        }

        else {

            console.log('isOnlyAlphabetNumber is false',);
            // Notify wrong inputs
            NotificationManager.error('Please check your input !');

        }



    }

    render() {

        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        return (

            <div className='popup_inner'>

                <div className="new-bankacc col-md-12">
                    {/* <form onSubmit={this.handleSubmit}> */}
                    <div className='col-md-4'>
                        <label>
                            New Bank Account Name
                        </label>
                    </div>

                    <div className='input col-md-4'>
                        <input type="text" value={this.state.value} onChange={this.handleChange} />
                    </div>

                    <div className='row col-md-4'>
                        <button className='btn-primary' onClick={() => this.handleSubmit()}>Confirm</button>
                        <button className='btn-primary' onClick={this.props.closePopup}>Cancel</button>
                    </div>

                    {/* <input type="submit" value="Submit" /> */}

                    {/* </form> */}
                </div>

                <NotificationContainer />

            </div>

        )

    }

}

class Bank_Account_Mgm extends Component {

    constructor(props) {

        super(props);

        this.state = {
            accounts: [],
            showPopup: false,
            redirectLogout: false
        }
        this.togglePopup = this.togglePopup.bind(this);
        this.handleNewBankAcc = this.handleNewBankAcc.bind(this);
        this.getAllBankAccounts = this.getAllBankAccounts.bind(this);
    }


    componentDidMount() {

        this.getAllBankAccounts()
            .then((accounts) => {
                this.setState({ accounts: accounts });
            })

    }

    togglePopup = _ => {
        console.log('togglePopup');
        this.setState({ showPopup: !this.state.showPopup });
    }

    handleNewBankAcc = _ => {
        this.togglePopup();
    }

    deleteFromAccountList = (id) => {
        console.log('deleteFromAccountList', id);
        this.setState({ accounts: this.state.accounts.filter(account => account.BankAccID !== id) })
    }

    addToAccountList = (account) => {

        if (account) {
            console.log('addToAccountList', account.BankAccID, account.BankAccName);

            var { accounts } = this.state;
            accounts.push(account)
            this.setState({ accounts: accounts })
        }

    }

    getAllBankAccounts = _ => {

        var that = this;

        return new Promise(function (resolve, reject) {

            var url = `api/v1/bankacc`;

            fetch(backend + url, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    console.log(data);
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else {
                        resolve(data);
                    }
                })
                .catch((err) => {
                    console.log('getPlanWithAccOverAPeriod error', err);
                    reject(err)
                })

        })

    }



    renderRows = account => {
        return (
            <BankAccRow key={account.BankAccID} account={account} deleteFromAccountList={this.deleteFromAccountList} />
        )
    }


    renderTable = _ => {

        const { accounts } = this.state;

        if (accounts.length) {


            return (

                <div className="bank-acc-table">

                    <table className="table table-striped table-hover ">
                        <thead>
                            <tr>
                                <th>Account Name</th>
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {accounts.map(this.renderRows)}
                        </tbody>

                    </table>

                </div>
            )
        }
        else {
            return (
                <div className="bank-acc-table">
                    <h5>No Bank Accounts found</h5>
                </div>
            )
        }


    }


    render() {

        let bankAccTable = this.renderTable();

        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        let content = (

            <div className='bank-acc-mgm'>
                <h3>Bank Accounts</h3>

                <div>

                    {(this.state.showPopup) ?
                        <div className='add_bank_acc'>
                            <RemoveCircleOutlineIcon onClick={this.togglePopup.bind(this)} />
                            <label>Add Bank Account</label>
                            <AddNewBankAccPopup
                                closePopup={this.togglePopup.bind(this)}
                                addToAccountList={this.addToAccountList}
                            />
                        </div>
                        :
                        <div className='add_bank_acc'>
                            <AddCircleIcon onClick={this.handleNewBankAcc} />
                            <label>Add Bank Account</label>
                        </div>
                    }
                </div>

                <div>
                    {bankAccTable}
                </div>
                <NotificationContainer />

            </div>
        )

        return (content);

    }

}

export default Bank_Account_Mgm;